import styled from 'styled-components';
import { LeftSide } from './LeftSide';
export const RightSide = styled(LeftSide) `
  transform: scaleX(-1);
`;
//# sourceMappingURL=RightSide.js.map